module.exports = __webpack_public_path__ + "assets/img/tongdian2.1387614a.png";